"use strict";
import smoothscroll from 'smoothscroll-polyfill';
import "./carousel";
import { debounce, isMobile, goTo } from './utils';

(() => {

    window.goTo = goTo;

    function maskTelefone2(e) {
        var v = e.target.value;
        v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito

        if (v.length < 2) v = v.replace(/^(\d)/g, "($1");
        else if (v.length <= 2) v = v.replace(/^(\d\d)/g, "($1");
        //Coloca parênteses em volta dos dois primeiros dígitos
        else v = v.replace(/^(\d\d)(\d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos

        if (v.length >= 14) v = v.replace(/(\d{5})(\d)/, "$1-$2");
        //Coloca hífen entre quinto e sexto dígitos
        else v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos

        e.target.value = v;
    }

    function scrollTargetGoTo(stringTarget) {
        const elem_target = document.querySelector('#' + stringTarget);

        if (elem_target) {
            location.hash = '#' + stringTarget;
            goTo(elem_target.offsetTop - 70);
        }
    }

    window.addEventListener('DOMContentLoaded', () => {
        const links_scroll = document.querySelectorAll('[data-scroll]');
        var forms = document.querySelectorAll('.needs-validation');

        window.__forceSmoothScrollPolyfill__ = true;
        smoothscroll.polyfill();

        AOS.init();

        document.body.classList.add("loaded");

        // trata o click dos links internos
        Array.prototype.slice.call(links_scroll)
            .forEach(function (link) {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    var args = link.getAttribute("href").substr(1).split('?');
                    if (args.length && args[0]) {
                        scrollTargetGoTo(args[0]);
                    }
                });
            });
        // trata o click dos links internos

        // Loop over them and prevent submission
        Array.prototype.slice.call(forms)
            .forEach(function (form) {
                form.addEventListener('submit', function (event) {
                    event.preventDefault()
                    event.stopPropagation()

                    form.classList.add('was-validated');

                    if (form.checkValidity()) {
                        if (event.target.classList.contains("request-interesse"))
                            window.requestInteresse(event.target);
                    }


                }, false)
            })

        var allFones = document.querySelectorAll(".mascara-fone");
        Array.prototype.forEach.call(allFones, function (el) {
            el.addEventListener("keyup", maskTelefone2);
            el.addEventListener("keypress", maskTelefone2); //   el.addEventListener("change", telefone);

            el.addEventListener("change", maskTelefone2); //   el.addEventListener("change", telefone);
        });

        const mobile = isMobile();
        const navbarPrincipal = document.querySelector(".navbar.navbar-principal");

        if (!mobile && navbarPrincipal) {

            const funcScroll = () => {


                if (window.innerWidth <= 768) {
                    document.querySelector(".navbar.navbar-principal").classList.remove("scroll");
                    return
                }

                if (window.pageYOffset > 133)
                    document.querySelector(".navbar.navbar-principal").classList.add("scroll");
                else
                    document.querySelector(".navbar.navbar-principal").classList.remove("scroll");

            }

            funcScroll();
            window.addEventListener('scroll', debounce(funcScroll, 200));
            window.addEventListener('resize', debounce(funcScroll, 200));

        }


    });

    window.onload = () => {
        var args = location.hash.substr(1).split('?');

        if (args.length && args[0]) {
            scrollTargetGoTo(args[0]);
        }
    };

})();